<script setup>
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import { Skeleton as VanSkeleton } from 'vant';
import { ref, watch, inject, computed } from 'vue';

const props = defineProps({
	loading: {
		type: Boolean,
		default: false
	},
	empty: {
		type: Boolean,
		default: false
	}
});

const getDisplayType = inject('MODULE_DISPLAY_TYPE');
const useSkeleton = computed(() => {
	return getDisplayType === 'overview';
});

// 仅响应首次加载状态变更
const firstLoadDone = ref(false);
const displayLoading = ref(false);
watch(
	() => props.loading,
	newVal => {
		if (firstLoadDone.value) return;

		if (newVal) {
			displayLoading.value = true;
		} else if (displayLoading.value) {
			displayLoading.value = false;
			firstLoadDone.value = true;
		}
	},
	{ immediate: true }
);
</script>

<template>
	<div class="module-state-box">
		<template v-if="displayLoading">
			<van-skeleton v-if="useSkeleton" :row="3" :row-width="['100%', '100%', '100%']" />
			<!-- TODO 后续需要的话再去使用 LoadingMask.show -->
			<div v-else class="module-state-loading"></div>
		</template>
		<CFullEmpty v-else-if="empty" />
		<div v-else class="module-state-content">
			<!-- 需要额外的节点嵌套，来避免样式隔离问题 -->
			<slot></slot>
		</div>
	</div>
</template>

<style lang="less">
.van-skeleton {
	padding: 0;
	padding-bottom: 0.14rem;
}
</style>
<style lang="less" scoped>
.module-state-box {
	.module-state-loading {
		height: 0.6rem;
	}
	.module-state-content {
		height: 100%;
	}
}
</style>
